module.exports = __webpack_public_path__ + "img/facebook.2d51278c.svg";